// DEFAULT_PAGE_SIZE must be large enough to prevent fetching next page on first page load
// for store and network queries to prevent race condition with relay
export const DEFAULT_PAGE_SIZE = 100;

export const DEFAULT_USER_ROLE = "viewer";

export const EDIT_FORM_SUBMIT_BUTTON_NAME = "Save Changes";
export const EDIT_FORM_LOADING_SUBMIT_BUTTON_NAME = "Saving Changes";

export const DATETIME_FORMAT_STR = "MMM dd, yyyy, h:mm aa";

export const SEARCH_DEBOUNCE_MS = 200;
